import api from '@/api/api';
import type { ReloadType } from 'lib/models/reloadRequest';

export class ConnectionError extends Error {
  name = 'ConnectionError';

  constructor(message: string, cause?: unknown) {
    super(message, { cause });
  }
}

export interface ConnectionState {
  enabled: boolean;
  connected: boolean;
  error?: unknown;
}

const reloadApi = new (class ReloadApi {
  async reload(types: ReloadType[]) {
    await api.post('api/reload/all', { json: { types }, timeout: 120_000 });
  }
})();

export default reloadApi;
Object.assign(window, { reloadApi });
